import React from "react";
import { CheckCircle, ExternalLink, X } from "lucide-react";
import { Button } from "../ui/button";

// Vista previa del reporte de calibración (PDF sin validez) antes de finalizar.
// paraFinalizar: muestra "Confirmar y finalizar" para seguir al modal de sticker.
const VistaPreviaReporteModal = ({ url, paraFinalizar, onClose, onConfirmar }) => {
  if (!url) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-2 py-4">
      <div className="flex h-full w-full max-w-5xl flex-col overflow-hidden rounded-2xl bg-white shadow-xl">
        <div className="flex items-start justify-between gap-3 border-b px-4 py-3">
          <div>
            <h3 className="text-base font-semibold text-gray-900">
              Vista previa del reporte
            </h3>
            <p className="text-xs text-gray-500">
              {paraFinalizar
                ? "Revisa el reporte antes de finalizar. Al confirmar se asigna el N° de certificado y se genera el sello de integridad; después no podrás editar la calibración."
                : "Documento sin validez: el N° de certificado y el sello de integridad se generan al finalizar."}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Cerrar vista previa"
          >
            <X size={18} />
          </button>
        </div>

        <iframe
          title="Vista previa del reporte de calibración"
          src={url}
          className="min-h-0 w-full flex-1 bg-gray-100"
        />

        <div className="flex flex-col-reverse gap-2 border-t px-4 py-3 sm:flex-row sm:justify-end">
          <Button
            type="button"
            variant="outline"
            onClick={() => window.open(url, "_blank")}
          >
            <ExternalLink size={14} className="mr-1.5" />
            Abrir en pestaña nueva
          </Button>
          <Button type="button" variant="outline" onClick={onClose}>
            {paraFinalizar ? "Volver a editar" : "Cerrar"}
          </Button>
          {paraFinalizar && (
            <Button
              type="button"
              className="bg-green-600 hover:bg-green-700"
              onClick={onConfirmar}
            >
              <CheckCircle size={14} className="mr-1.5" />
              Confirmar y finalizar
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default VistaPreviaReporteModal;
